export default {"src":"/_next/static/media/reebeloCareIcon.51e0bee0.svg","height":87,"width":88};